import React, {FC, useState} from 'react';
import {connect} from 'react-redux';

import {ResolveDispatchProps} from '../../../../helpers/reduxHelpers';
import {makeMapStateToProps, ResolveStateProps} from '../../../../helpers/reselectHelpers';
import {getIsBlockedBilling} from '../../../../store/data/company/companySelectors';
import {
  getIsUserBillingContact,
  getIsUserGlobalAdmin,
} from '../../../../store/data/teammates/teammatesSelectors';
import {navigateToLinkAction} from '../../../../store/stateless/navigationActions';
import {BlockedBillingBanner} from './blockedBillingBanner';

/*
 * Props.
 */

type BlockedBillingBannerContainerStateProps = ResolveStateProps<typeof mapStateToProps>;
type BlockedBillingBannerContainerDispatchProps = ResolveDispatchProps<typeof mapDispatchToProps>;
type BlockedBillingBannerContainerComponentProps = BlockedBillingBannerContainerStateProps &
  BlockedBillingBannerContainerDispatchProps;

/*
 * Component.
 */

export const BlockedBillingBannerContainerComponent: FC<BlockedBillingBannerContainerComponentProps> = (
  props,
) => {
  const {isGlobalAdmin, isBillingContact, isBlockedBilling, onOpenBillingClick} = props;
  const [isDismissed, setIsDismissed] = useState(false);

  const shouldDisplayBanner = isGlobalAdmin && isBillingContact && isBlockedBilling && !isDismissed;
  if (!shouldDisplayBanner) {
    return null;
  }

  return (
    <BlockedBillingBanner onDismissClick={() => setIsDismissed(true)} onLinkClick={onOpenBillingClick} />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  isGlobalAdmin: getIsUserGlobalAdmin,
  isBlockedBilling: getIsBlockedBilling,
  isBillingContact: getIsUserBillingContact,
}));

const mapDispatchToProps = {
  onOpenBillingClick: () => navigateToLinkAction('/settings/billing'),
};

export const BlockedBillingBannerContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(BlockedBillingBannerContainerComponent);
